// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#WaterImpairments {
  width: 90vw !important;
  height: 40vh !important; }

.table-report-container {
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  margin: 0; }
  .table-report-container #FHBPReport-report {
    width: 90vw;
    height: 40vh; }
  .table-report-container .table-report-map-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40vh; }
    .table-report-container .table-report-map-container th,
    .table-report-container .table-report-map-container td {
      color: white; }
  .table-report-container .table-row {
    position: relative;
    display: flex;
    justify-content: center; }
    .table-report-container .table-row .minmax {
      position: absolute;
      top: 0%;
      right: 0%;
      z-index: 10000;
      width: 25px; }
      .table-report-container .table-row .minmax svg {
        color: white; }
  .table-report-container .table-report-table-container {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 10;
    height: 40vh;
    overflow: auto;
    width: 90vw; }
    .table-report-container .table-report-table-container table {
      position: absolute;
      left: 0; }
    .table-report-container .table-report-table-container th,
    .table-report-container .table-report-table-container td {
      color: white; }
  .table-report-container .height-unset {
    height: 17vh; }
  .table-report-container .table-report-graph-container {
    height: 40vh; }
  .table-report-container h4 {
    text-align: right;
    color: white;
    margin-right: 1rem; }
    .table-report-container h4 a {
      color: #4fc32c;
      font-size: 18px; }
  .table-report-container .marker {
    border: 3px solid #df542c;
    border-radius: 50%;
    font-size: 24px;
    color: transparent; }

#LayerDataReport {
  position: relative; }
  #LayerDataReport .map-legend-container #mapLegendAccordion {
    position: absolute;
    right: 0; }

.expanded-table-report {
  margin-top: -21% !important;
  height: 75vh !important;
  max-height: unset; }

.OWQPReport-report-table-container th {
  min-width: 140px;
  text-align: center; }

.OWQPReport-report-table-container td {
  text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/features/reports/TableReport/table-report.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB,EAAA;;AAGzB;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS,EAAA;EAJX;IAOI,WAAW;IACX,YAAY,EAAA;EARhB;IAYI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY,EAAA;IAfhB;;MAmBM,YAAY,EAAA;EAnBlB;IAwBI,kBAAkB;IAClB,aAAa;IACb,uBAAuB,EAAA;IA1B3B;MA4BM,kBAAkB;MAClB,OAAO;MACP,SAAS;MACT,cAAc;MACd,WAAW,EAAA;MAhCjB;QAkCQ,YAAY,EAAA;EAlCpB;IAwCI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,WAAW,EAAA;IA/Cf;MAiDM,kBAAkB;MAClB,OAAO,EAAA;IAlDb;;MAsDM,YAAY,EAAA;EAtDlB;IA0DkB,YAAY,EAAA;EA1D9B;IA6DI,YAAY,EAAA;EA7DhB;IAiEI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB,EAAA;IAnEtB;MAqEM,cAAc;MACd,eAAe,EAAA;EAtErB;IA2EI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB,EAAA;;AAKtB;EACE,kBAAkB,EAAA;EADpB;IAIM,kBAAkB;IAClB,QAAQ,EAAA;;AAKd;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB,EAAA;;AAGnB;EAEI,gBAAgB;EAChB,kBAAkB,EAAA;;AAHtB;EAOI,kBAAkB,EAAA","sourcesContent":["#WaterImpairments {\n  width: 90vw !important;\n  height: 40vh !important;\n}\n\n.table-report-container {\n  flex-direction: column;\n  height: 100%;\n  max-width: 100%;\n  margin: 0;\n\n  #FHBPReport-report {\n    width: 90vw;\n    height: 40vh;\n  }\n\n  .table-report-map-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 40vh;\n\n    th,\n    td {\n      color: white;\n    }\n  }\n\n  .table-row {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    .minmax {\n      position: absolute;\n      top: 0%;\n      right: 0%;\n      z-index: 10000;\n      width: 25px;\n      svg {\n        color: white;\n      }\n    }\n  }\n\n  .table-report-table-container {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    z-index: 10;\n    height: 40vh;\n    overflow: auto;\n    width: 90vw;\n    table {\n      position: absolute;\n      left: 0;\n    }\n    th,\n    td {\n      color: white;\n    }\n  }\n\n  .height-unset { height: 17vh; }\n\n  .table-report-graph-container {\n    height: 40vh;\n  }\n\n  h4 {\n    text-align: right;\n    color: white;\n    margin-right: 1rem;\n    a {\n      color: #4fc32c;\n      font-size: 18px;\n    }\n  }\n\n  .marker {\n    border: 3px solid #df542c;\n    border-radius: 50%;\n    font-size: 24px;\n    color: transparent;\n  }\n\n}\n\n#LayerDataReport {\n  position: relative;\n  .map-legend-container {\n    #mapLegendAccordion {\n      position: absolute;\n      right: 0;\n    }\n  }\n}\n\n.expanded-table-report {\n  margin-top: -21% !important;\n  height: 75vh !important;\n  max-height: unset;\n}\n\n.OWQPReport-report-table-container {\n  th { \n    min-width: 140px;\n    text-align: center;\n  }\n\n  td {\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
